import { routes } from 'routes/routes';
import { Empty, Icon, Link } from 'ui';
import { useDebounce } from 'common/hooks';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { EntityList } from 'features/channels/components';
import { useProgramsInfiniteQuery } from '../../../queries';

type P = {
  filter: {
    search?: string;
  };
  getPathToProgramDetail: (id: string) => string;
};

const JoinedProgramsListContent = ({ filter: { search: propertySearch }, getPathToProgramDetail }: P) => {
  const { isDebouncing, value: search } = useDebounce(propertySearch);
  const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useProgramsInfiniteQuery({
    filter: { scope: 'joined', search, status: 'published' },
    pagination: { pageSize: 12 },
  });

  const programs = data?.pages.flat().flatMap((programsPaginated) => programsPaginated.data);

  const isFilteredView = Boolean(search);

  return (
    <EntityList
      empty={
        // TODO: Use same empty state as on Videos page
        <Empty
          description={{
            subtitle: isFilteredView
              ? 'There are no programs to display here'
              : 'Discover new content that is right for you in our Channels',
            title: isFilteredView ? 'No programs' : 'You haven’t registered for any program yet',
          }}
          image={<Icon icon="mortarboard-line" />}
        >
          {isFilteredView ? null : <Link to={routes.channels.index}>Go to channels</Link>}
        </Empty>
      }
      entities={programs?.map((program) => ({
        data: program,
        type: 'Program',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToProgramDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      isLoading={isDebouncing || isLoading}
    />
  );
};

export default JoinedProgramsListContent;
